export const clearArray = (a: unknown[]): void => {
  a.splice(0, a.length);
};
